import {t} from '@lingui/macro'
import {i18n} from "@lingui/core";


const v = (value) => {
    try {
        return `${value.toLocaleString(i18n.locale)}`
    } catch (e) {
        return value
    }
}


const labelFormatter = (unit) => (item) => {
    const d = new Date(item.label)
    d.setMinutes(d.getMinutes() - item.dataset.minutes)
    return `${d.toLocaleString(i18n.locale)}: ${v(item.raw)}${unit}`
}

const timeTickFormatter = (value) => {
    const v = new Date(value)
    if (!v.getMinutes()) {
        return v.toLocaleTimeString(i18n.locale, {hour: 'numeric', minute: '2-digit'});
    }
}


const defaultParams = {
    'default': {
        fontSize: 14,
        fontWeight: 'bold',
        lineWidth: 3,
        scaleBorderWidth: 3,
        scaleLineWidth: 2,
        maintainAspectRatio: true
    },
    '768': {
        fontSize: 12,
        fontWeight: 'normal',
        lineWidth: 2,
        scaleBorderWidth: 2,
        scaleLineWidth: 1.5,
        maintainAspectRatio: true
    },
    '576': {
        fontSize: 11,
        fontWeight: 'normal',
        lineWidth: 1.5,
        scaleBorderWidth: 1.5,
        scaleLineWidth: 1,
        maintainAspectRatio: false
    },
}

export const getDefaultParams = (windowInnerWidth) => {
    if (windowInnerWidth > 768) {
        return defaultParams['default']
    } else if (windowInnerWidth > 576) {
        return defaultParams['768']
    } else {
        return defaultParams['576']
    }
}


export const getChartConfig = (settings) => {
    const ret = {};
    Object.entries(settings.charts).filter(([key, data]) => data.display).map(([key, data]) =>
        ret[key] = {
            htmlId: data.htmlId,
            params: [data.param],
            maxLength: 120,
            legend: {
                [data.param]: {label: data.label, color: '#000000'}
            },
            options: {
                locale: i18n.locale,
                elements: {
                    point: {
                        radius: 0,
                    }
                },
                legend: {
                    display: true,
                },
                responsive: true,
                animation: {
                    duration: 500
                },
                scales: {
                    y: {
                        ticks: {
                            callback: v,
                            color: "#000000",
                        },
                        title: {
                            display: false,
                            text: `${data.label} (${data.unit})`,
                            align: 'end',
                            color: 'rgba(0, 30, 58, 1)',
                        }
                    },
                    x: {
                        grid: {
                            borderColor: '#000000',
                            borderWidth: 3,
                            lineWidth: 10,
                            color: '#ffcb51',
                        },
                        title: {
                            display: false,
                            text: `${data.time_label} (${data.time_unit})`,
                            align: 'end',
                            color: 'rgba(0, 30, 58, 1)',
                        },
                        type: 'time',
                        ticks: {
                            maxRotation: 90,
                            minRotation: 90,
                            color: '#000000',
                            source: 'labels',
                            callback: timeTickFormatter
                        },
                        time: {
                            unit: 'minutes',
                            round: true,
                        }
                    },
                },
                plugins: {
                    chartAreaBorder: {
                        color: '#ffcb51',
                    },
                    verticalLine: {
                        dash: [3, 3],
                        color: 'rgba(0, 0, 0, 0.5)',
                        width: 2,
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            title: () => (data.label),
                            label: labelFormatter(data.unit)
                        }
                    },
                    legend: {
                        display: false,
                        position: 'bottom',
                    },
                    title: {
                        display: false,
                        text: data.title
                    }
                }

            }
        })
    return ret
}
